import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "shared/context/auth-context";
import { canOperateCustomerPortal } from "./access";

const PortalOperatorGuard = ({ children }) => {
  const auth = useContext(AuthContext);
  if (!canOperateCustomerPortal(auth)) {
    return <Navigate to="/not-found" replace />;
  }
  return children;
};

export default PortalOperatorGuard;
